<dash-content *ngIf="team" [teamId]="team"></dash-content>
